@if (image) {
  <img [src]="image" class="image" alt="" />
}
<mat-icon [svgIcon]="icon()" [class.mat-icon-rtl-mirror]="rtlMirrorIcon()" muloSvgViewbox class="icon"></mat-icon>
<span class="title">{{ title() }}</span>
